module.exports = __webpack_public_path__ + "static/media/_decline.3ed1774c.svg";